export default __webpack_public_path__ + "static/media/modernjs.8c710ae7.jpg";